import { render } from "./Edit.vue?vue&type=template&id=05fc082f"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Tasks/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05fc082f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05fc082f', __exports__)) {
    api.reload('05fc082f', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=05fc082f", () => {
    api.rerender('05fc082f', render)
  })

}


export default __exports__